import { render } from "./NewsHome.vue?vue&type=template&id=20ad0e78"
import script from "./NewsHome.vue?vue&type=script&lang=js"
export * from "./NewsHome.vue?vue&type=script&lang=js"

import "./NewsHome.vue?vue&type=style&index=0&id=20ad0e78&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__